import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// Interfaces
export interface DeleteChatSessionResponse {
  success: boolean;
  message: string;
}

// Axios request
export function deleteChatSession(
  chat_session_uid: string,
): Promise<AxiosResponse<DeleteChatSessionResponse>> {
  return axios.delete<DeleteChatSessionResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/session/${chat_session_uid}`,
  );
}
